import type {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from 'ag-grid-community'

/**
 * `branded` is a nullable boolean - on master products and on counterparty
 * mapping details - surfaced in the UI as Branded / Unbranded / -- rather than
 * a two-state Yes/No.
 */
export const BRANDED_EMPTY_LABEL = '--'
export const BRANDED_LABEL = 'Branded'
export const UNBRANDED_LABEL = 'Unbranded'

/** Raw cell values, in dropdown order, for an agSelectCellEditor. */
const BRANDED_VALUES = [null, true, false]

/** Labels, in dropdown order, for an antd Select. */
export const BRANDED_OPTIONS = [
  BRANDED_EMPTY_LABEL,
  BRANDED_LABEL,
  UNBRANDED_LABEL,
]

const brandedLabel = (value: unknown): string => {
  if (value === true) return BRANDED_LABEL
  if (value === false) return UNBRANDED_LABEL
  return BRANDED_EMPTY_LABEL
}

/**
 * Grid column config for a `branded` field, shared by the master data and
 * reference data grids. The formatter is what labels the unset option in the
 * editor's dropdown, where a blank row would be hard to see; the renderer
 * leaves the cell itself blank so it reads as "settable, currently not set".
 */
export const brandedColumnDef: Pick<
  ColDef,
  'cellEditor' | 'cellEditorParams' | 'cellRenderer' | 'valueFormatter'
> = {
  cellEditor: 'agSelectCellEditor',
  cellEditorParams: {
    values: BRANDED_VALUES,
  },
  cellRenderer: ({ value }: ICellRendererParams) => {
    if (value !== true && value !== false) return null
    return brandedLabel(value)
  },
  valueFormatter: ({ value }: ValueFormatterParams) => brandedLabel(value),
}
